<div *ngIf="!loaded" style="height: 10px;"></div>
<div *ngIf="loaded">
  <iui-messages #messages class="ms-auto me-auto"> </iui-messages>
</div>

<div *ngIf="brandError" class="alert alert-danger alert-dismissible">
  <strong class="me-1" *ngIf="brandError.title">{{brandError.title}}</strong>
  <span [innerHTML]="brandError.text" [ngClass]="{'me-3': brandError.dismissible}"></span>
  <button *ngIf="brandError.dismissible" type="button" style='font-size: x-small' class="btn-close btn-close-white " (click)="brandError = undefined;" aria-label="Close">
  </button>
</div>

<h2 class="mb-5"> Edit Application Details for Short Code {{ scId }} </h2>

<ng-template [ngIf]="scId && model">
  <h5> CSC Registrant </h5>
  <div class="my-3">
    <app-address-book (addressChosen)="loadApplicantAddress($event)"></app-address-book>
  </div>
  <div class="row my-4">
    <div class="col-3">
      <strong>Account ID:</strong>
      {{ model.accountId }}
    </div>
    <div class="col-3 truncate" tooltipPosition="top" [pTooltip]="model.company" appShowToolTipIfTruncated>
      <strong>Organization Name:</strong>
      {{ model.company }}
    </div>
  </div>
  <form id="application-form" (keydown.enter)="handleEnter($event)" class="presubmit" #application="ngForm" (ngSubmit)="next(application)">
    <div class="row my-4">
      <div class="col-5">
        <label for="appFirstName" class="required">First Name</label>
        <input appScrText placeholder="First Name" appFirstNameValidator required maxlength="{{MaxLen.FirstName}}" id="appFirstName" name="appFirstName" #appFirstName="ngModel"
          [(ngModel)]="model.firstName" />
        <app-error-msg [field]="appFirstName" fieldLabel="First Name"></app-error-msg>
      </div>
      <div class="col-5">
        <label for="appLastName" class="required">Last Name</label>
        <input appScrText placeholder="Last Name" appLastNameValidator required maxlength="{{MaxLen.LastName}}" id="appLastName" name="appLastName" #appLastName="ngModel"
          [(ngModel)]="model.lastName" />
        <app-error-msg [field]="appLastName" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-3">
        <label for="appPhoneInput" class="required">Phone Number</label>
        <app-phone [(ngModel)]="model.phone" #appPhone="ngModel" class="col-12" required name="appPhone" id="appPhone"></app-phone>
        <app-error-msg [field]="appPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-2">
        <label for="appExt">Extension</label>
        <input appScrText [(ngModel)]="model.phoneExtension" id="appExt" name="appExt" maxlength="{{MaxLen.PhoneExtension}}" />
      </div>
      <div class="col-5">
        <label for="appEmail" class="required">Email</label>
        <input appScrText placeholder="Email" required appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" maxlength="{{MaxLen.Email}}" id="appEmail" name="appEmail" #appEmail="ngModel" [(ngModel)]="model.email" />
        <app-error-msg [field]="appEmail" fieldLabel="Email"></app-error-msg>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-4">
        <label for="appCountryInput" class="required">Country</label>
        <app-country-dropdown id="appCountry" [(ngModel)]="model.country" name="appCountry" #appCountry="ngModel"></app-country-dropdown>
        <app-error-msg [field]="appCountry" fieldLabel="Country"></app-error-msg>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-12">
        <label for="appAddress1" class="required">Street Address 1</label>
        <input appScrText placeholder="Street Address 1" required maxlength="{{MaxLen.Address}}" id="appAddress1" name="appAddress1" #appAddress1="ngModel"
          [(ngModel)]="model.address1" />
        <app-error-msg [field]="appAddress1" fieldLabel="Address"></app-error-msg>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-12">
        <label for="appAddress2">Street Address 2</label>
        <input appScrText placeholder="Street Address 2" maxlength="{{MaxLen.Address}}" id="appAddress2" name="appAddress2" #appAddress2="ngModel" [(ngModel)]="model.address2" />
      </div>
    </div>
    <div class="row my-4">
      <div class="col-4">
        <label for="appCity" class="required">City</label>
        <input appScrText placeholder="City" required maxlength="{{MaxLen.City}}" id="appCity" name="appCity" #appCity="ngModel" [(ngModel)]="model.city" />
        <app-error-msg [field]="appCity" fieldLabel="City"></app-error-msg>
      </div>
      <div class="col-4">
        <label for="appRegionInput" [ngClass]="{ required: getRegionRequired() }">State/Province</label>
        <app-region-dropdown [(ngModel)]="model.state" [country]="model.country" name="appRegion" #appRegion="ngModel" id="appRegion"></app-region-dropdown>
        <app-error-msg [field]="appRegion" fieldLabel="State/Province"></app-error-msg>
      </div>
      <div class="col-4">
        <label for="appZipInput" [ngClass]="{ required: getRegionRequired() }">Zip/Postal Code</label>
        <app-zipcode-input [(ngModel)]="model.zip" [country]="model.country" name="appZip" #appZip="ngModel" id="appZip" inputId="appZipInput"
          placeholder="Zip/Postal Code"></app-zipcode-input>
        <app-error-msg [field]="appZip" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>

    <hr />

    <app-intended-usage [usagesEnabled]="usagesEnabled" [codeType]="codeType" [largeHeadingSize]="false" (update)="setCodeType($event)" />

    <div class="form-row mt-4">
      <div class="mb-3 col-8">

        <p-checkbox class="p-formcontrol" name="intendedUsageInfo" label="Update Intended Short Code Usage on Invoice/Receipt" id="intendedUsageInfo" inputId="binary"
          [binary]="true" [(ngModel)]="isInvoiceUpdate"></p-checkbox>
        <sup><i class="fa fa-circle-info large ms-1" style="color: #004381;"
            pTooltip="If there are multiple short codes on this order, the Intended Usage will not be updated for all of them. If this was paid as part of a multi-invoice payment, that receipt will not be updated. If this short code was transferred as a pre-paid short code, there is no invoice or receipt to update. Refer to the Download Transfer Statement on the Short Code List for receipt of transfer."
            appendTo="body" tooltipPosition="top" appendTo="body" tooltipStyleClass="toolCardData"></i></sup>
      </div>
    </div>
    <hr />

    <h5>Associated Brand Clients</h5>
    <div class="row">
      <div class="col-8 mt-2">
        The Brand Client is the entity whose message content is being sent to wireless subscribers.
        In this section, you must identify all vetted brand clients associated with the short code(s).
        <div class="row mt-4">
          <div class="col-12">
            <label for="brandClients" [ngClass]="{ required: !model.parkedCode && !model.demoCode }">Brand
              Clients</label>

            <p-multiSelect id="brandClients" appMs name="brandClients" #bc selectedItemsLabel="{0} Brand Clients selected" [maxSelectedLabels]='maxSelectedLabels'
              class="p-formcontrol" (onChange)="brandSelected(bc, $event)" [required]="!model.parkedCode && !model.demoCode" [showToggleAll]="false" #brandClients="ngModel"
              optionValue="value" optionLabel="label" [options]="brandOptions" [(ngModel)]="model.brandIds" placeholder="Select Brand Clients"
              scrollHeight="250px" [style]="{'width': '640px'}" [panelStyle]="{'width':'400px'}" [display]="multiSelectDisplay"
              [disabled]="codeType === 'demo' || codeType === 'parked'">
              >
              <ng-template let-group pTemplate="group">
                <div class="flex align-items-center">
                  <span>{{ group.label }}</span>
                </div>
              </ng-template>
            </p-multiSelect>
            <app-error-msg [field]="brandClients" fieldLabel="Brand Clients"></app-error-msg>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <h5>Content Provider</h5>
    <div class="row">
      <div class="col-8 mt-2">
        A Content Provider is the entity who has a contractual relationship with the brand that is sending
        messages to wireless subscribers. In this section, you must identify the Content Provider associated
        with the short code(s).  Content Providers are defined from the My Partners&nbsp;&gt;&nbsp;Content Provider List page.
        On that page, you can also access a report of Content Providers for existing short code leases.
      </div>
      <div class="col-5 mt-4">
        <label for="contentProvider" [ngClass]="{ required: codeType === 'active' }">Content Provider</label>
        <p-dropdown appDd [filter]="true" placeholder="Select Content Provider" [options]="contentProviderOptions" optionLabel="label" optionValue="value"
          [required]="codeType === 'active'" name="contentProvider" id="contentProvider" #contentProvider="ngModel" [(ngModel)]="model.cpId"></p-dropdown>
        <app-error-msg [field]="contentProvider" fieldLabel="Content Provider"></app-error-msg>
      </div>
    </div>
  
    <hr />

    <h5> Direct Connection Aggregator </h5>
    <div class="row my-4">
      <div class="col-5">
        <label for="aggregator" class="required">Direct Connection Aggregator</label>
        <p-dropdown appDd [filter]="true" placeholder="Direct Connection Aggregator" [options]="aggregators" optionLabel="name" optionValue="aggregatorId" [required]="true"
          id="aggregator" name="aggregator" #aggregator="ngModel" [(ngModel)]="model.aggregatorId"></p-dropdown>
        <app-error-msg [field]="aggregator" fieldLabel="Direct Connection Aggregator"></app-error-msg>
      </div>
    </div>
    <hr />

    <h5> Application Service Provider </h5>
    <div class="row my-4">
      <div class="col-8">
        <label for="appProvider" class="required">Application Service Provider</label>
        <input appScrText placeholder="Application Service Provider" required maxlength="{{MaxLen.ApplicationProvider}}" id="appProvider" name="appProvider" #appProvider="ngModel"
          [(ngModel)]="model.applicationProvider" />
        <app-error-msg [field]="appProvider" fieldLabel="Application Service Provider"></app-error-msg>
      </div>
    </div>
    <hr />

    <h5> Is this code for a Political Campaign? </h5>
    <div class="row my-4">
      <div class="col-2">
        <p-radioButton name="political" label="No" [value]="false" [(ngModel)]="model.forPoliticalCampaign" (click)="clearFields()"></p-radioButton>
      </div>
      <div class="col-2">
        <p-radioButton name="political" label="Yes" [value]="true" [(ngModel)]="model.forPoliticalCampaign" (click)="selectCampaignType()"></p-radioButton>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-4">
        <span class="me-3">Political Campaign Status: </span>
        <span *ngIf="model.forPoliticalCampaign">{{model.politicalCampaignStatus}}</span>
      </div>
    </div>

    <div class="my-4">
      <label for="politicalCampaignComments">Comments</label>
      <textarea rows="5" cols="75" [(ngModel)]="model.politicalCampaignComments" class="form-control form-text" name="politicalCampaignComments" id="politicalCampaignComments"
        disabled></textarea>
    </div>

    <div class="row my-4">
      <div class="col-4">
        <label for="campaignType" [ngClass]="{ required: model.forPoliticalCampaign }">Campaign Type</label>
        <p-dropdown appDd (onChange)="onChangeCampaignType(campaignTypeChoice)" [options]="campaignTypeOptions" [(ngModel)]="campaignTypeChoice" scrollHeight="400"
          name="campaignTypeDD" id="campaignTypeDD" #campaignTypeDD="ngModel" [disabled]="!model.forPoliticalCampaign">
        </p-dropdown>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4">
        <label for="fecId">FEC ID (Format: 9 Alphanumeric Characters)</label>
        <input appScrText appUppercase mask="AAAAAAAAA" appFecIdValidator [validation]="false" placeholder="FEC ID" [(ngModel)]="model.fecId" #fecId="ngModel" id="fecId"
          name="fecId" [disabled]="!model.forPoliticalCampaign || model.politicalCampaignType !== 'Federal'" (ngModelChange)="onModelChange()" />
        <app-error-msg [field]="fecId" fieldLabel="FEC ID"></app-error-msg>
      </div>
    </div>
    <div class="row col-4">
      <small>
        The FEC ID is a unique identifier for the political campaign. An FEC ID is 9 alphanumeric characters,
        starting with C, H, S, or P.
      </small>
    </div>

    <div class="row mt-4">
      <div class="col-4">
        <label for="politicalCampaignInfo">Filing URL or Other Identifying Information</label>
        <input appScrText [maxlength]="255" [(ngModel)]="model.politicalCampaignInfo" placeholder="Filing URL or other identifying information" #politicalCampaignInfo="ngModel"
          id="politicalCampaignInfo" name="politicalCampaignInfo" [disabled]="!model.forPoliticalCampaign || model.politicalCampaignType === 'Federal'"
          (ngModelChange)="onModelChange()" />
      </div>
    </div>
    <div class="row col-4">
      <small>
        Use this space to provide identifying information about the political campaign.
        Alternately, you can indicate that additional information will be sent to the Short Code Registry separately.
      </small>
    </div>
    <hr />

    <h5>Registry Comments</h5>
    <div class="my-4">
      <textarea rows="5" cols="75" [(ngModel)]="model.registryComments" class="form-control form-text" name="registryComments" id="registryComments" disabled></textarea>
    </div>

    <div class="footer">
      <div type="submit">
        <button id="save-button" class="btn btn-primary">
          Save
        </button>
        <button id="cancel-button" class="btn btn-secondary ms-3" (click)="cancel()">
          Cancel
        </button>
      </div>
    </div>
  </form>
</ng-template>

<p-confirmDialog key='confirmParkedCodes' #confirmParkedCodes width="425" [closable]="false" [blockScroll]="false">
  <p-footer>
    <button i18n id="confirmParkedCodesAccept" class="btn btn-primary me-2" (click)="confirmParkedCodes.accept()">Yes</button>
    <button i18n id="confirmParkedCodesReject" class="btn btn-secondary" (click)="confirmParkedCodes.reject()">No</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='confirmDemoCodes' #confirmDemoCodes width="425" [closable]="false" [blockScroll]="false">
  <p-footer>
    <button i18n id="confirmDemoCodesAccept" class="btn btn-primary me-2" (click)="confirmDemoCodes.accept()">Yes</button>
    <button i18n id="confirmDemoCodesReject" class="btn btn-secondary" (click)="confirmDemoCodes.reject()">No</button>
  </p-footer>
</p-confirmDialog>